import { render, staticRenderFns } from "./ModalInstagram.vue?vue&type=template&id=e1ad3d60&scoped=true"
import script from "./ModalInstagram.vue?vue&type=script&lang=js"
export * from "./ModalInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ad3d60",
  null
  
)

export default component.exports